import React from 'react';
import { Card } from 'react-bootstrap';
import { OvertimeReviewRow } from '../../../Components/TripClaims/TripClaimRows';
import { overtimeEntryId, overtimeTotalMinutes } from '../../../Utils/driverOvertime';

export { waitingChargeDescription } from '../Functions/tripClaimLineItems';

/**
 * Overtime the driver recorded from the portal — timed at the pickup or the
 * drop-off, or reported afterwards as minutes — each reviewed like a receipt,
 * with the total. Pricing the time is left to the admin ("Create line item"
 * seeds the description only) — the rates live on the vehicle category /
 * operator pricing profile.
 *
 * `claims` is the booking's useBookingClaims state; the rows are the Trip
 * claims page's own.
 */
function DriverOvertimeSection({ claims, onCreateLineItem }) {
  const { overtime: entries, busyId, reviewOvertime } = claims;
  const total = overtimeTotalMinutes(entries);

  return (
    <Card className="mb-3" data-testid="driver-overtime-section">
      <Card.Header className="fw-bold d-flex align-items-center justify-content-between">
        <span>
          <i className="fa fa-hourglass-half me-2" />
          Overtime
        </span>
        {entries.length > 0 && (
          <span className="small fw-normal" data-testid="overtime-total">{`Total ${total} min`}</span>
        )}
      </Card.Header>
      <Card.Body>
        {!entries.length ? (
          <p className="text-muted mb-0">No waiting overtime recorded.</p>
        ) : entries.map((entry, index) => {
          const id = overtimeEntryId(entry);
          return (
            <OvertimeReviewRow
              // An entry with neither id nor date can't be addressed; its
              // position is all there is to key it by.
              // eslint-disable-next-line react/no-array-index-key
              key={id || index}
              entry={entry}
              busy={busyId === id}
              onReview={(decision) => reviewOvertime(entry, decision)}
              onCreateLineItem={onCreateLineItem ? () => onCreateLineItem({ kind: 'overtime', entry }) : undefined}
            />
          );
        })}
      </Card.Body>
    </Card>
  );
}

export default DriverOvertimeSection;
